import "./AboutScreen.css";

export default function AboutScreen({ profile, aboutText }) {
  return (
    <section className="section" id="about">
      <div className="sectionHeader">
        <div className="sectionNum">01.</div>
        <div className="sectionTitle">About</div>
      </div>

      <p className="muted prewrap aboutText">{aboutText}</p>
    </section>
  );
}
